export default __webpack_public_path__ + "static/2-fad83f177d6b58121d37779706c63fc7.jpg";